// Single source of truth for Orange Street ticketing (frontend, display-only).
//
// Orange Street is sold EXCLUSIVELY through Eventbrite — there is no on-site
// cart/checkout. These tiers are shown for information; every "Get Tickets"
// CTA links to ORANGE_STREET_EVENTBRITE_URL.

export const ORANGE_STREET_EVENT_ID = 16;

export const ORANGE_STREET_EVENTBRITE_URL =
  'https://www.eventbrite.com/e/orange-street-band-live-tickets-1990527144272?aff=oddtdtcreator';

// General-admission style pricing tiers.
export const ORANGE_STREET_TIERS = [
  {
    id: 't16-early',
    name: 'Early Bird',
    price: 20,
    perks: ['Lowest price', 'Live show + before & after party'],
  },
  {
    id: 't16-ga',
    name: 'General Admission',
    price: 40,
    perks: ['Live show + before & after party', 'Full bar access'],
  },
  {
    id: 't16-vip',
    name: 'VIP Experience',
    price: 95,
    perks: ['Priority entry lane', 'Meet & greet', 'Welcome drink'],
  },
];

// VIP tables share one inventory pool (24 total, 5 sold) across three options.
export const ORANGE_STREET_VIP_TABLES = {
  totalTables: 24,
  soldTables: 5,
  options: [
    {
      id: 't16-table-1btl',
      name: 'VIP Table — 1 Bottle',
      price: 1000,
      perks: ['Reserved table', '1 premium bottle', 'Priority entry lane'],
    },
    {
      id: 't16-table-2btl',
      name: 'VIP Table — 2 Bottles',
      price: 1300,
      perks: ['Reserved table', '2 premium bottles', 'Priority entry lane'],
    },
    {
      id: 't16-table-premium',
      name: 'Premium VIP',
      price: 1500,
      perks: ['Best-location table', 'Premium bottle service', 'Dedicated host', 'Priority entry lane'],
    },
  ],
};

export const orangeStreetTablesAvailable = () =>
  Math.max(0, ORANGE_STREET_VIP_TABLES.totalTables - ORANGE_STREET_VIP_TABLES.soldTables);
